import { configureStore } from '@reduxjs/toolkit'
import { baseAPI } from './baseAPI'

export const store = configureStore({
  reducer: {
    // RTK Query injects its reducer here
    [baseAPI.reducerPath]: baseAPI.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(baseAPI.middleware)
})
